export default {
  title: "Perguntas frequentes",
  still_needs_help: "Ainda precisa de ajuda ?",
  enter_in_contact: "Entre em contato para que possamos ajuda-lo!",
  mobile_label: "Celular",
  tell_label: "Telefone",
  contact_by_whatsapp: "Contato por whatsapp",
};
